/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum PlatformEnum {
    AZURE = 'azure',
    SUPERMICRO = 'supermicro',
    VMWARE = 'vmware',
    DELL = 'dell',
    AMAZON = 'amazon',
    HYPERV = 'hyperv',
    KVM = 'kvm',
    XEN = 'xen',
    NUTANIX = 'nutanix'
}
